export default {
  sections: {
    order_summary: 'Total del pedido',
  },
  labels: {
    add_items: 'Añade artículos para empezar',
    item_count_one: '{{count}} artículo',
    item_count_other: '{{count}} artículos',
  },
  buttons: {
    return: 'Volver a revisar el pedido',
  },
};
